
<select [ngModel]="accessLevel" (change)="accessLevelChanged($event)">
  <option *ngFor="let level of options" [value]="level[0]">{{ level[1] }}</option>
</select>